export function clearRedpacket() {
  return {
    type: 'CLEAR_REDPACKET_INFO',
  };
}
export function loadRedpacketHome() {
  return {
    type: 'LOAD_REDPACKET_HOME',
  };
}

export function loadRedpacketHomeCompletion(error = null, data = {}) {
  return {
    type: 'LOAD_REDPACKET_HOME_COMPLETION',
    error,
    data,
  };
}

export function loadRedpacketConfig() {
  return {
    type: 'LOAD_REDPACKET_CONFIG',
  };
}

export function loadRedpacketConfigCompletion(error = null, data = {}) {
  return {
    type: 'LOAD_REDPACKET_CONFIG_COMPLETION',
    error,
    data,
  };
}

export function updateRedpacketView(viewId) {
  return {
    type: 'UPDATE_REDPACKET_VIEW',
    viewId,
  };
}

export function loadRedpacketResult(id, key, score, couponId, fromUid) {
  return {
    type: 'LOAD_REDPACKET_RESULT',
    id,
    key,
    score,
    couponId,
    fromUid: fromUid || null,
  };
}
export function loadRedpacketResultCompletion(error = null, data = {}) {
  return {
    type: 'LOAD_REDPACKET_RESULT_COMPLETION',
    error,
    data,
  };
}

export function receiveRedpacketCoupon() {
  return {
    type: 'RECEIVE_REDPACKET_COUPON',
  };
}
export function receiveRedpacketCouponCompletion(error = null, data = {}) {
  return {
    type: 'RECEIVE_REDPACKET_COUPON_COMPLETION',
    error,
    data,
  };
}

export function loadRedpacketNotice() {
  return {
    type: 'LOAD_REDPACKET_NOTICE',
  };
}
export function loadRedpacketNoticeCompletion(error = null, data = {}) {
  return {
    type: 'LOAD_REDPACKET_NOTICE_COMPLETION',
    error,
    data,
  };
}
